/**
 * @generated SignedSource<<0be98e9836b36a14f3ecb1a017a5a35e>>
 * @relayHash eae3f029eeffbe1e2da24bd39b35162a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50ce5ef04d3badd7a165b493b9dfe5db963fd356442508323160227190ab2bad

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateUrlFieldInput = {
  id: string;
  operation: JiraUrlFieldOperationInput;
};
export type JiraUrlFieldOperationInput = {
  operation: JiraSingleValueFieldOperations;
  uri?: string | null | undefined;
};
export type url_issueFieldUrl_UrlField_Mutation$variables = {
  input: JiraUpdateUrlFieldInput;
};
export type url_issueFieldUrl_UrlField_Mutation$data = {
  readonly jira: {
    readonly updateUrlField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly " $fragmentSpreads": FragmentRefs<"url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type url_issueFieldUrl_UrlField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateUrlField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly fieldId: string;
        readonly id: string;
        readonly name: string;
        readonly type: string;
        readonly uri: string | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type url_issueFieldUrl_UrlField_Mutation = {
  rawResponse: url_issueFieldUrl_UrlField_Mutation$rawResponse;
  response: url_issueFieldUrl_UrlField_Mutation$data;
  variables: url_issueFieldUrl_UrlField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "url_issueFieldUrl_UrlField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUrlFieldPayload",
            "kind": "LinkedField",
            "name": "updateUrlField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraUrlField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "url_issueFieldUrlInlineEditFull_UrlInlineEditViewIsEditable_fragmentRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "url_issueFieldUrl_UrlField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUrlFieldPayload",
            "kind": "LinkedField",
            "name": "updateUrlField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraUrlField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "fieldId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "uri"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "50ce5ef04d3badd7a165b493b9dfe5db963fd356442508323160227190ab2bad",
    "metadata": {},
    "name": "url_issueFieldUrl_UrlField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "60222c1fb24270ee0c27b8d3bfc763a4";

export default node;
